<template>
  <SupportPageCard
    page-class="work-search"
    :title="languages.FAQ || 'FAQ'"
    :show-back="!hideBackBtn"
    @back="back"
  >
    <template #toolbar>
      <van-search
        ref="search"
        class="work-search-toolbar-search"
        :placeholder="languages.inputWorkSearch"
        background="transparent"
        clearable
        shape="round"
        clear-trigger="always"
        v-model="originSearchValue"
        @clear="() => onInput({ target: { value: '' } })"
        @focus="clearResult"
      >
        <template #left-icon>
          <div></div>
        </template>
        <template #right-icon>
          <van-button
            class="work-search-toolbar-btn"
            round
            block
            type="info"
            @click="onRefreshList"
          >
            {{ languages.smartOrderSearch }}
          </van-button>
        </template>
      </van-search>
    </template>

    <div class="work-search-body">
      <div class="work-search-result" v-if="workList">
        <FaqItem
          v-for="(item, index) in workList"
          :key="item.SUPPORT_ORDER_ID"
          :faqItem="item"
          :index="index"
          :visibleControl="item.visibleControl"
          :transitionDelay="item.transitionDelay"
        ></FaqItem>
      </div>
      <p
        v-if="finishedList && workList.length === 0"
        class="work-search-result-tip"
      >
        {{ languages.smartOrderNoResult }}
      </p>
      <div class="work-search-wrap" v-if="!isJumpAiBot">
        <section-title
          :title="languages.smartOrderCreate"
          v-show="hasWorkTempList && !searchValue"
        ></section-title>
        <work-temp-list
          v-show="hasWorkTempList && !searchValue"
          :source="locationType.searchPage"
        ></work-temp-list>
      </div>
    </div>
  </SupportPageCard>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SupportPageCard from '@components/officialSupport/common/SupportPageCard.vue';
import FaqItem from '@components/officialSupport/FaqItem.vue';
import SectionTitle from '@components/officialSupport/common/SectionTitle.vue';
import WorkTempList from '@components/officialSupport/WorkTempList.vue';
import iframeMessage from '@mixins/officialSupport/iframeMessage';
import { locationType } from '@plugins/biPoint/_configOfficialSupport';
import pointStayTime from '@mixins/officialSupport/pointStayTime';
import aiBot from '@mixins/officialSupport/aiBot';
import globalConfig from '@utiles/globalConfig';

const hideBackBtn = globalConfig.getHrefParam('hideBackBtn') == 1;

export default {
  name: 'WorkSearch',
  mixins: [iframeMessage, pointStayTime, aiBot],
  data() {
    return {
      originSearchValue: undefined,
      searchValue: undefined, // 搜索关键字
      loadingList: false, // 加载中
      finishedList: false, // 列表数据全部加载完
      workList: [], //搜索列表数据
      errorLoad: false,
      timer: null,
      locationType,
      hideBackBtn
    };
  },
  computed: {
    ...mapState({
      languages: state => state.languages,
      letter: state => state.languages?.mylist,
      workTempList: state => state.workTempList
    }),
    hasWorkTempList() {
      return this.workTempList?.length > 0;
    }
  },
  created() {
    this.postMessageToParent('visibleLangChoose', false);
  },
  methods: {
    ...mapActions(['getWorkList', 'searchFaq']),
    clearResult() {
      this.workList = [];
      this.finishedList = false;
    },
    back() {
      if (globalConfig.isTiktokMiniProgram()) {
        this.$router.push('/workhome');
      } else {
        this.$router.go(-1);
      }
    },
    // 监听原生搜索框input时间
    listenerSearchInput() {
      const searchRef = this.$refs?.search;
      const searchRoot = searchRef?.$el || searchRef;
      const searchInputEle = searchRoot?.querySelector?.(
        '.van-field__control'
      );
      if (searchInputEle) {
        searchInputEle.addEventListener('input', this.onInput);
      }
    },
    // 取消监听原生搜索框input时间
    unListenerSearchInput() {
      const searchRef = this.$refs?.search;
      const searchRoot = searchRef?.$el || searchRef;
      const searchInputEle = searchRoot?.querySelector?.(
        '.van-field__control'
      );
      if (searchInputEle) {
        searchInputEle.removeEventListener('input', this.onInput);
      }
    },
    onInput(e) {
      const value = e?.target?.value;
      this.searchValue = value;
      this.clearResult();
      clearTimeout(this.timer);
      if (value === void 0 || value === '') {
        this.workList = [];
        this.finishedList = false;
        return;
      }
      this.timer = setTimeout(
        async () => {
          try {
            window.scrollTo(0, 0);
          } catch (e) {
            console.error(e);
          }
          await this.onRefreshList();
        },
        value === void 0 || value === '' ? 0 : 600
      );
    },
    // 重新加载工单列表
    async onRefreshList() {
      this.workList = [];
      // 表示可以重新加载数据
      this.finishedList = false;
      // 重新加载数据,将 loadingList 设置为 true，表示处于加载状态
      this.loadingList = true;
      // 开始加载
      await this.onLoadList();
      return Promise.resolve();
    },
    // 加载工单列表
    async onLoadList() {
      try {
        if (this.searchValue) {
          window.csorderDataLayer.push({
            eventName: 'faqSearch',
            eventValue: {
              text: this.searchValue || ''
            }
          });
        }
        const submitKeyword =
          this.searchValue && this.searchValue.trim() !== ''
            ? this.searchValue
            : '';
        const data = await this.searchFaq({
          content: submitKeyword,
          searchType: 1
        });
        const newData = data?.articleList?.length ? data.articleList : [];
        const decorateNewData = [];
        for (let i = 0, len = newData.length; i < len; i++) {
          const item = newData[i];
          item.visibleControl = false; // 控制置顶和删除操作是否显示
          item.transitionDelay = i * 0.2; // 动画延迟加载 0.2s * 索引值
          decorateNewData.push(item);
        }
        this.workList.push(...newData);
        this.finishedList = true;
        // 表示本次加载完成，这个计算是等插入动画完成后才是加载完成
        await new Promise(resolve => {
          setTimeout(() => {
            this.loadingList = false;
            resolve();
          }, newData.length * 100);
        });
      } catch (e) {
        console.log(e);
        this.loadingList = false;
        this.errorLoad = true;
      }
      return Promise.resolve();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.listenerSearchInput();
    });
  },
  beforeMount() {
    this.unListenerSearchInput();
  },
  components: {
    SupportPageCard,
    FaqItem,
    SectionTitle,
    WorkTempList
  }
};
</script>
